import {
  ArmyListUnitOption,
  dupArmyListUnitUnitOption,
} from './army-list-unit-option';
import { UnitCarac } from '../ninthAge/UnitCarac';
import { ArmyListUnitTroop } from './army-list-unit-troop';
import { ArmyListUnitVersioning } from './versioning/ArmyListUnitVersioning';
import { Organisation } from '../ninthAge/Organisation';
import { Unit } from '../ninthAge/Unit';
import { ArmyListUnitModelRuleTroop } from './army-list-unit-model-rule-troop';
import { IPositionnable } from '../IPositionnable';
import { IPriceable } from '../IPriceable';

export interface ArmyListUnit
  extends ArmyListUnitVersioning,
    IPositionnable,
    IPriceable {
  syncId: string | null;
  unit_id: number;
  unitName: string;
  mountId: number | null;
  mount: Unit | null;
  organisation_id: number;
  organisations: Organisation[];
  size: number;
  carac: UnitCarac;
  is_enabled: boolean;
  isDeleted: boolean;
  errorSync: boolean;
  notes: string | null;
  magic: string | null;
  army_list_unit_unit_options: ArmyListUnitOption[];
  troops: ArmyListUnitTroop[];
  modelRuleUnitTroops: ArmyListUnitModelRuleTroop[];
}

export const dupArmyListUnit = (item: ArmyListUnit): ArmyListUnit => {
  return {
    ...item,
    id: '',
    syncId: null,
    carac: {
      ...item.carac,
    },
    army_list_unit_unit_options: item.army_list_unit_unit_options.map((item) =>
      dupArmyListUnitUnitOption(item),
    ),
    troops: item.troops.map(
      (troop) =>
        ({
          ...troop,
          id: '',
        }) satisfies ArmyListUnitTroop as ArmyListUnitTroop,
    ),
    modelRuleUnitTroops: item.modelRuleUnitTroops.map(
      (rule) =>
        ({
          ...rule,
          id: '',
          isSelected: false,
        }) satisfies ArmyListUnitModelRuleTroop as ArmyListUnitModelRuleTroop,
    ),
  } satisfies ArmyListUnit as ArmyListUnit;
};
